import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import UnauthenticatedRoute from './UnauthenticatedRoute';
import Login from '../pages/Auth/Login';
import VerifyEmail from '../pages/Auth/Verifications/VerifyEmail';
import PrivateRoute from './PrivateRoute';
import PrivateOutlet from './PrivateOutlet';
import PrivateOutletSimple from './PrivateOutletSimple';
import MainPage from '../pages/Main/Main';
import ErrorPage from '../pages/Error/Error';
import Home from '../pages/Home/Home';
import BlocksManagement from '../pages/Master/BlocksManagement/Index';
import ImagesManagement from '../pages/Master/BlockImagesManagement/BlockImagesManagement';
import VideosManagement from '../pages/Master/BlockVideosManagement/BlockVideosManagement';
import InquiryManagement from '../pages/Inquiry/list/InquiryManagement';
import MyPage from '../pages/My/Index';
import Register from '../pages/Auth/Register';
import PasswordReset from '../pages/Auth/PasswordReset';
import MyAccountIndex from '../pages/My/Account/Index';
import ChangePasswordIndex from '../pages/My/Account/ChangePassword/Index';
import ChangedEmailWithSuccess from '../pages/Auth/Confirmations/ChangedEmailWithSucess';
import Plans from '../pages/My/Account/Plans/Index';
import PaymentMethod from '../pages/My/Account/PaymentMethod/Index';
import AddInquiryForm from '../pages/Inquiry/create/AddInquiryForm';
import UpdateInquiryForm from '../pages/Inquiry/edit/UpdateInquiryForm';
import InquiryPreview from '../pages/Inquiry/preview/InquiryPreview';
import UserSites from '../pages/My/UserSites/UserSites';
import FilesPage from '../pages/My/Files/FilesPage';
import InquiryPreviewList from '../pages/Inquiry/preview/InquiryPreviewList';
import InquiryPreviewDetail from '../pages/Inquiry/preview/InquiryPreviewDetail';

function Router(): React.ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateOutlet defaultNav displaySideBar />}>
          <Route path="/" element={<PrivateRoute feature="user_logged"><Home /></PrivateRoute>} />
          <Route path="/me" element={<PrivateRoute feature="user_logged"><MyPage /></PrivateRoute>} />
          <Route path="/user-sites" element={<PrivateRoute feature="user_logged"><UserSites /></PrivateRoute>} />
          <Route path="/files" element={<PrivateRoute feature="user_logged"><FilesPage /></PrivateRoute>} />
          <Route path="/my-blocks-management" element={<BlocksManagement />} />
          <Route path="/my-images-management" element={<ImagesManagement />} />
          <Route path="/my-videos-management" element={<VideosManagement />} />
          <Route path="/inquiry-management" element={<InquiryManagement />} />
          <Route path="/inquiry-management/add" element={<AddInquiryForm />} />
          <Route path="/inquiry-management/edit/:id" element={<UpdateInquiryForm />} />
        </Route>

        <Route path="/" element={<PrivateOutlet defaultNav displaySideBar={false} displayAccountSideBar />}>
          <Route path="/my-account" element={<PrivateRoute feature="user_logged"><MyAccountIndex /></PrivateRoute>} />
          <Route path="/my-account/change-password" element={<PrivateRoute feature="user_logged"><ChangePasswordIndex /></PrivateRoute>} />
          <Route path="/my-account/change-email/:token" element={<PrivateRoute feature="user_logged"><ChangedEmailWithSuccess /></PrivateRoute>} />
          <Route path="/my-account/plans" element={<PrivateRoute feature="user_logged"><Plans /></PrivateRoute>} />
          <Route path="/my-account/payment-methods" element={<PrivateRoute feature="user_logged"><PaymentMethod /></PrivateRoute>} />
        </Route>

        <Route path="/" element={<PrivateOutlet defaultNav={false} displaySideBar={false} />}>
          <Route path="/pages/:id" element={<PrivateRoute feature="user_logged"><MainPage /></PrivateRoute>} />
        </Route>

        <Route path="/" element={<PrivateOutletSimple />} />
        <Route path="/inquiry-management/preview" element={<InquiryPreview />} />
        <Route path="/inquiry-management/preview/layout/list" element={<InquiryPreviewList />} />
        <Route path="/inquiry-management/preview/layout/detail" element={<InquiryPreviewDetail />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/login" element={<UnauthenticatedRoute><Login /></UnauthenticatedRoute>} />
        <Route path="/verify-email" element={<UnauthenticatedRoute><VerifyEmail /></UnauthenticatedRoute>} />
        <Route path="/verify-email/forgot-password" element={<UnauthenticatedRoute><VerifyEmail forgotPassword /></UnauthenticatedRoute>} />
        <Route path="/register/:token" element={<UnauthenticatedRoute><Register /></UnauthenticatedRoute>} />
        <Route path="/forgot-password/:token" element={<UnauthenticatedRoute><PasswordReset /></UnauthenticatedRoute>} />
        <Route path="/*" element={<div> Not found </div>} />
      </Routes>
    </BrowserRouter>

  );
}
export default Router;
